import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Link
} from '@jutro/components';
import SpmConstants from 'sg-spm-constants';
import CommonConstants from 'sg-common-constants';
import { useLocation } from 'react-router-dom';
import messages from './SgCaisModalCtrl.messages';

function SgCaisModalCtrl(props) {
    const {
        isOpen,
        onConfirm,
        onCancel,
        className,
        response,
        onResolve
    } = props;

    const translator = useContext(TranslatorContext);
    const location = useLocation();
    const currentLocation = useRef(location);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';
    const contactUsPhoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_CAIS_COMMON_PHONE_NUMBER;

    const title = translator(messages.CaisModalHeader);
    let message;
    let confirmLabel;
    let cancelLabel;

    const handleCancel = (event) => {
        if (event) {
            event.preventDefault();
        }
        onResolve();
        onCancel();
    };

    const handleConfirm = (event) => {
        if (event) {
            event.preventDefault();
        }
        onResolve();
        onConfirm();
    };

    switch (response) {
        case SpmConstants.CAIS_RESPONSE.ERROR_ALLOWED_MONTHLY:
            message = translator(messages.CaisErrorAllowedMonthlyMessage);
            confirmLabel = translator(messages.CaisModalContinue);
            break;
        case SpmConstants.CAIS_RESPONSE.ERROR_NOT_ALLOWED_MONTHLY:
            message = translator(messages.CaisErrorNotAllowedMonthlyMessage);
            confirmLabel = translator(messages.CaisModalContinueToCardPayment);
            cancelLabel = translator(messages.CaisModalBackToQuote);
            break;
        case SpmConstants.CAIS_RESPONSE.PASSED_CHECK_CACHE:
            message = translator(messages.CaisModalPassedCheckCacheMessage);
            confirmLabel = translator(messages.CaisModalContinue);
            break;
        case SpmConstants.CAIS_RESPONSE.FAILED_CHECK_CACHE:
            message = (
                <>
                    <p>
                        {translator(messages.CaisModalFailedCheckCacheMessageP1)}
                    </p>
                    <p>
                        {translator(messages.CaisModalFailedCheckCacheMessageP2, {
                            phoneNumber: isMobile
                                ? <a href={`tel:${contactUsPhoneNumber.replaceAll(' ', '')}`}>{contactUsPhoneNumber}</a>
                                : contactUsPhoneNumber
                        })}
                        <Link
                            id="experianLink"
                            href="https://www.experian.co.uk/"
                            onClick={onResolve}
                        >
                            {translator(messages.CaisModalFailedCheckCacheMessageP2Link)}
                        </Link>
                    </p>
                </>
            );
            cancelLabel = translator(messages.CaisModalBackToQuote);
            break;
        case SpmConstants.CAIS_RESPONSE.FAILED_CHECK_SERVICE:
            message = (
                <>
                    <p>
                        {translator(messages.CaisModalFailedCheckServiceMessageP1)}
                        <Link
                            href="/"
                            id="caisContinue"
                            onClick={handleConfirm}
                        >
                            {translator(messages.CaisModalFailedCheckServiceMessageP1Link)}
                        </Link>
                    </p>
                    <p>
                        {translator(messages.CaisModalFailedCheckServiceMessageP2, {
                            phoneNumber: isMobile
                                ? <a href={`tel:${contactUsPhoneNumber.replaceAll(' ', '')}`}>{contactUsPhoneNumber}</a>
                                : contactUsPhoneNumber
                        })}
                        <Link
                            id="experianLink"
                            href="https://www.experian.co.uk/"
                            onClick={onResolve}
                        >
                            {translator(messages.CaisModalFailedCheckServiceMessageP2Link)}
                        </Link>
                    </p>
                </>
            );
            confirmLabel = translator(messages.CaisModalContinueToCardPayment);
            cancelLabel = translator(messages.CaisModalBackToQuote);
            break;
        default:
            break;
    }

    useEffect(() => {
        if (currentLocation.current !== location) {
            handleCancel();
        }
    }, [location]);

    return (
        <ModalNext isOpen={isOpen}>
            <div className={`${className} sgInfoModal sgConfirmationModal`}>
                <img id="sagaLogo" alt="Saga Logo" className="logoImage" src="https://asset.saga.co.uk/common/brand2021/logo/Saga_Logo_Indigo.svg" />
                <ModalHeader title={title} />
                <ModalBody>
                    {message}
                </ModalBody>
                <ModalFooter>
                    {confirmLabel && (
                        <Button onClick={handleConfirm}>
                            {confirmLabel}
                        </Button>
                    )}
                    {cancelLabel && (
                        <Link href="/" id="caisCancel" onClick={handleCancel}>
                            {cancelLabel}
                        </Link>
                    )}
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

SgCaisModalCtrl.propTypes = {
    isOpen: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func
};

SgCaisModalCtrl.defaultProps = {
    isOpen: true,
    onConfirm: () => { },
    onCancel: () => { }
};

export default SgCaisModalCtrl;
